import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "@/api/auth";
import { Button, Input } from "@/components";
import { useLang } from "@/i18n/LanguageContext";

const SLUG_KEY = "obf_login_slug";

export function ForgotPasswordPage() {
  const { t } = useLang();
  const [tenantSlug, setTenantSlug] = useState(() => localStorage.getItem(SLUG_KEY) ?? "");
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await requestPasswordReset(email, tenantSlug.trim() || undefined);
    } catch {
      // Anti-enumeration: never reveal failures — show the same confirmation.
    } finally {
      setBusy(false);
      setDone(true);
    }
  }

  return (
    <div className="center-col">
      <p className="eyebrow">{t("Wachtwoord vergeten", "Forgot password")}</p>
      <h1 style={{ marginBottom: 8 }}>{t("Stuur mij een herstellink", "Send me a reset link")}</h1>
      {done ? (
        <>
          <p style={{ color: "var(--grey-text)", marginBottom: 24 }}>
            {t(
              "Als er een account bij dit e-mailadres hoort, is er een herstellink verstuurd. Controleer je inbox.",
              "If an account exists for this address, a reset link has been sent. Check your inbox.",
            )}
          </p>
          <Link to="/login" className="btn btn-outline">{t("Terug naar inloggen", "Back to log in")}</Link>
        </>
      ) : (
        <>
          <p style={{ color: "var(--grey-text)", marginBottom: 24 }}>
            {t("Vul je organisatie en e-mailadres in.", "Enter your organisation and e-mail address.")}
          </p>
          <form onSubmit={onSubmit}>
            <Input
              label={t("Organisatie (slug)", "Organisation (slug)")}
              name="organization"
              autoComplete="organization"
              placeholder={t("bijv. acme — leeg laten voor platform-beheer", "e.g. acme — leave empty for platform admin")}
              value={tenantSlug}
              onChange={(e) => setTenantSlug(e.target.value)}
            />
            <Input label={t("E-mail", "Email")} name="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <Button type="submit" disabled={busy}>{busy ? t("Bezig…", "Working…") : t("Herstellink versturen", "Send reset link")}</Button>
          </form>
          <p style={{ marginTop: 18 }}>
            <Link to="/login" className="eyebrow">{t("← Terug naar inloggen", "← Back to log in")}</Link>
          </p>
        </>
      )}
    </div>
  );
}
